'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { useTranslations } from 'next-intl';
import type React from 'react';
import { useRef } from 'react';
import { Tag } from '@/components/elementary/Tag';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { SITE_HEADER_OFFSET_MOBILE, STICKY_HEADER_BOTTOM_THRESHOLD } from '@/constants/pricing.constants';
import { useRefSticky } from '@/hooks/useRefSticky';
import { formatEventName, useAnalytics } from '@/lib/analytics/analytics';
import { ANALYTICS_EVENTS } from '@/lib/analytics/analytics.constants';
import { cn } from '@/lib/styles';
import { PRICING_TEST_IDS } from '@/lib/test-ids';
import type { PricingItem } from '@/types/api/pricing.types';
export function PlanTabs(t0) {
  const $ = _c(24);
  const {
    data,
    currentTab,
    setCurrentTab,
    renderContent,
    className
  } = t0;
  const t = useTranslations("Pricing");
  const {
    track
  } = useAnalytics();
  const stickyRef = useRef(null);
  const {
    isSticky
  } = useRefSticky(stickyRef, SITE_HEADER_OFFSET_MOBILE, STICKY_HEADER_BOTTOM_THRESHOLD);
  let t1;
  if ($[0] !== setCurrentTab || $[1] !== track) {
    t1 = value => {
      track({
        eventType: formatEventName(ANALYTICS_EVENTS.PRICING_PLAN_TAB_CLICKED),
        eventProperties: {
          planName: value
        }
      });
      setCurrentTab(value);
    };
    $[0] = setCurrentTab;
    $[1] = track;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleTabChange = t1;
  const t2 = isSticky ? "pt-3 border-neutral-light-100 transition-colors duration-150 ease-in-out" : "border-transparent";
  let t3;
  if ($[3] !== t2) {
    t3 = cn("sticky flex justify-center w-auto px-0 -mx-6  z-20 top-[var(--site-header-offset-mobile)] pb-0 h-auto rounded-none bg-brand-black border-b", t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== data || $[6] !== t) {
    t4 = data?.map(item => <TabsTrigger value={String(item?.title)} key={`${item?.id}-tab`} data-test-id={PRICING_TEST_IDS.CONTENT_TAB_TRIGGER} className="group/tabs-trigger px-5 py-3 text-neutral-light-100 data-[state=active]:bg-neutral-light-100 data-[state=active]:text-brand-black transition-colors duration-200 ease-in-out"><span className="lok-text-body-bold-medium">{item?.title}</span>{item?.mostPopular && <Tag name={t("mostPopular")} size="small" className="w-fit text-sm lg:text-sm ml-1.25 -mr-1.25 group-data-[state=active]/tabs-trigger:text-neutral-light-100 group-data-[state=active]/tabs-trigger:bg-brand-black transition-colors duration-200 ease-in-out" fontWeight="font-bold" active={true} customColors={{
        backgroundColor: "neutral-light-100",
        borderColor: "neutral-light-100",
        textColor: "brand-black"
      }} />}</TabsTrigger>);
    $[5] = data;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <div className="flex overflow-auto px-6 pb-3 w-auto no-scrollbar">{t4}</div>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <TabsList className={t3} ref={stickyRef}>{t5}</TabsList>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== data || $[14] !== renderContent) {
    t7 = data?.map(item_0 => <TabsContent forceMount={true} className="w-full col-start-1 row-start-1 data-[state=inactive]:invisible" value={String(item_0?.title)} key={`${item_0?.id}-content`} data-test-id={PRICING_TEST_IDS.CONTENT_TAB_CONTENT}>{renderContent ? renderContent(item_0) : null}</TabsContent>);
    $[13] = data;
    $[14] = renderContent;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <div className="grid">{t7}</div>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== className || $[19] !== currentTab || $[20] !== handleTabChange || $[21] !== t6 || $[22] !== t8) {
    t9 = <Tabs data-test-id={PRICING_TEST_IDS.CONTENT_TAB} value={currentTab} onValueChange={handleTabChange} className={className}>{t6}{t8}</Tabs>;
    $[18] = className;
    $[19] = currentTab;
    $[20] = handleTabChange;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}